import { Grid, Typography } from "@mui/material";

export const ClinicWeightPresentationText = () => {
  return (
    <Grid item>
      <Typography variant="h6" ml={{ xs: 0, md: 3 }} mb={2}>
        Liebe Patientinnen und Patienten,
      </Typography>
      <Typography variant="body2" ml={{ xs: 0, md: 3 }} mb={2}>
        herzliche Willkommen in der Schulungsoberfläche für Ihr MMK-Programm.
        Mit diesen Videos können Sie die Vorbereitung auf ihre
        Adipositas-Operation optimal ergänzen.
      </Typography>
      <Typography variant="body2" ml={{ xs: 0, md: 3 }} mb={2}>
        Bei Fragen zur Organisation wenden Sie sich bitte an Ihr
        Adipositas-Zentrum.
      </Typography>
      <Typography variant="body2" ml={{ xs: 0, md: 3 }} mb={2}>
        Ihr Team von Weight Doctors und adipositasgutachten.de
      </Typography>
    </Grid>
  );
};
